import { useEffect } from "react";
import SoundManager from "../managers/sound-manager";
import useLocals from "./use-locals";
import { checkiOS } from "../checkIOS";
import { fadeOutBgAudio } from "../fade-audio";

type UseSoundParams = keyof typeof SoundManager.ambientSounds;

const useAmbientSound = (props: UseSoundParams, play = true) => {
  const soundName = props;
  const { getValue } = useLocals();

  useEffect(() => {
    const sound = SoundManager.ambientSounds[soundName];
    sound.loop = true;

    // if sounds are disabled mute all audios
    for (const [, value] of Object.entries(SoundManager.vfxSounds)) {
      value.muted = !!getValue("soundsDisabled");
    }

    // Handle mute state changes
    const isSoundDisabled = !!getValue("soundsDisabled");
    if (isSoundDisabled) {
      // Sound is muted - pause this sound
      if (!sound.paused) {
        sound.pause();
      }
    } else {
      // Sound is unmuted - play this sound if it should be playing
      if (play && sound.paused) {
        sound.play().catch(() => {
          // Autoplay not allowed - user interaction required
        });

        if (!checkiOS()) {
          if (sound.currentTime < 1) {
            sound.muted = true;
            sound.volume = 0;
          }

          sound.muted = false;
          const fadeAudio = setInterval(function () {
            if (sound.volume >= 0.8) {
              sound.volume = 1;
              clearInterval(fadeAudio);
            } else {
              sound.volume += 0.2;
            }
          }, 100);
        } else {
          sound.volume = 1;
          sound.muted = false;
        }
      }
    }

    return () => {
      // sound.pause();
      if (soundName !== "home" && sound.currentTime) {
        fadeOutBgAudio(sound);
      } else if (soundName === "home") {
        // sound.pause();
      }
      // sound.currentTime = 0;
    };
  }, [play, getValue]);
};

export default useAmbientSound;
